import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginFormWrapper from "./screens/Login/LoginFormWrapper";
import UserListingWrapper from "./screens/User/List/UserListingWrapper";
import FranchiseListingWrapper from "./screens/Franchise/List/FranchiseListingWrapper";
import AdvancePaymentListingWrapper from "./screens/AdvancePayments/List/AdvancePaymentListingWrapper";
import PaymentListingWrapper from "./screens/Payment/List/PaymentListingWrapper";
import PaymentModeListingWrapper from "./screens/PaymentMode/List/PaymentModeListingWrapper";
import CourseListingWrapper from "./screens/Course/List/CourseListingWrapper";
import LevelListingWrapper from "./screens/Level/List/LevelListingWrapper";
import SubjectListingWrapper from "./screens/Subject/List/SubjectListingWrapper";
import FacultyListingWrapper from "./screens/Faculty/List/FacultyListingWrapper";
import ModeListingWrapper from "./screens/Mode/List/ModeListingWrapper";
import DashboardWrapper from "./screens/Dashboard/DashboardWrapper";
import OfflineOrderListingWrapper from "./screens/OfflineOrders/List/OfflineOrderListingWrapper";
import AddOfflineOrderWrapper from "./screens/OfflineOrders/Add/AddOfflineOrderWrapper";
import CourseTypeListingWrapper from "./screens/CourseType/List/CourseTypeListingWrapper";
import AttemptListingWrapper from "./screens/Attempt/List/AttemptListingWrapper";
import ViewOfflineOrderLayout from "./screens/OfflineOrders/View/ViewOfflineOrderLayout";
import BookDetailsFormWrapper from "./screens/OfflineOrders/View/Tabs/BookDetails/BookDetailsFormWrapper";
import OrderDetailsFormWrapper from "./screens/OfflineOrders/View/Tabs/OrderDetails/OrderDetailsFormWrapper";
import PaymentDetailsFormWrapper from "./screens/OfflineOrders/View/Tabs/PaymentDetails/PaymentDetailsFormWrapper";
import { v4 as uuid } from "uuid";
import AuthHOC from "./AuthHOC";
import PageNotFound from "./PageNotFound";
import TicketViewLayout from "./screens/Franchise/View/TicketViewLayout/TicketViewLayout";
import FranchiseOrdersListingWrapper from "./screens/Franchise/View/FranchiseOrders/FranchiseOrdersListingWrapper";
import FranchiseLedgerListingWrapper from "./screens/Franchise/View/FranchiseLedger/FranchiseLedgerWrapper";
import ReceiptComponent from "./screens/Receipt/receipt";
import ReceiptDownload from "./screens/Receipt/DownloadReceipt";
import BooksListingWrapper from "./screens/Books/List/BooksListingWrapper";
import ExpenseCategoriesListingWrapper from "./screens/ExpenseCategories/List/ExpenseCategoriesListingWrapper";
import ProductManagementListingWrapper from "./screens/ProductManagement/List/ProductManagementListingWrapper";
import AmountListingWrapper from "./screens/Drawer/List/DrawerAmountListingWrapper";
import DrawerOutFlowFormWrapper from "./screens/Drawer/InOutFlow/DrawerOutFlowWrapper";
import DrawerExchangeFormWrapper from "./screens/Drawer/Exchange/DrawerExchangeFormWrapper";
import DrawerInFlowFormWrapper from "./screens/Drawer/InOutFlow/DrawerInFormWrapper";
import StudentListingWrapper from "./screens/Student/List/StudentListingWrapper";
import FuturePurchaseListingWrapper from "./screens/Future Purchase/List/FuturePurchaseListingWrapper";
import FuturePurchaseTicketViewLayout from "./screens/Future Purchase/View/TicketViewLayout/FuturePurchaseTicketViewLayout";
import FuturePurchaseFollowupNoteListingWrapper from "./screens/Future Purchase/View/FuturePurchaseNotes/FuturePurchaseFollowupNoteListingWrapper";
import UserRoleListingWrapper from "./screens/User-Role/List/UserRoleListingWrapper";
import ModuleProtectedRoute from "./ProtectedRoute";
import { moduleRoutes } from "./Config/moduleRoutes";
import StudentLedgerListingWrapper from "./screens/Student/View/StudentLedger/StudentLedgerWrapper";
import StudentOrdersListingWrapper from "./screens/Student/View/StudentOrders/StudentOrdersListingWrapper";
import StudentTicketViewLayout from "./screens/Student/View/TicketViewLayout/StudentTicketViewLayout";
import DuesListingWrapper from "./screens/Dues/List/DuesListingWrapper";
const PageRoutes = () => {
  const deviceId = localStorage.getItem("deviceId");

  if (!deviceId) {
    localStorage.setItem("deviceId", uuid());
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<PageNotFound />} />
          <Route path="/" element={<LoginFormWrapper />} />
          <Route
            path="/admin"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/admin"]}>
                <AuthHOC component={<UserListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/dashboard"]}>
                <AuthHOC component={<DashboardWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/franchise"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/franchise"]}>
                <AuthHOC component={<FranchiseListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/franchise/:franchiseId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/franchise"]}>
                <AuthHOC component={<TicketViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="order"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                  <AuthHOC component={<FranchiseOrdersListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
            <Route
              path="ledger"
              element={
                <AuthHOC component={<FranchiseLedgerListingWrapper />} />
              }
            />
          </Route>
          <Route
            path="/future-purchase"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/future-purchase"]}>
                <AuthHOC component={<FuturePurchaseListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/future-purchase/:futurePurchaseId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/future-purchase"]}>
                <AuthHOC component={<FuturePurchaseTicketViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="notes"
              element={
                <ModuleProtectedRoute
                  moduleId={moduleRoutes["/future-purchase"]}
                >
                  <AuthHOC
                    component={<FuturePurchaseFollowupNoteListingWrapper />}
                  />
                </ModuleProtectedRoute>
              }
            />
          </Route>

          <Route
            path="/advance-payment"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/advance-payment"]}>
                <AuthHOC component={<AdvancePaymentListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/product-management"
            element={
              <ModuleProtectedRoute
                moduleId={moduleRoutes["/product-management"]}
              >
                <AuthHOC component={<ProductManagementListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/drawer"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<AmountListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/cash-in"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<DrawerInFlowFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/cash-out"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<DrawerOutFlowFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/cash-exchange"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<DrawerExchangeFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/payments"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/payments"]}>
                <AuthHOC component={<PaymentListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/dues"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/dues"]}>
                <AuthHOC component={<DuesListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/student"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/student"]}>
                <AuthHOC component={<StudentListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/student/:studentId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/student"]}>
                <AuthHOC component={<StudentTicketViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="order"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                  <AuthHOC component={<StudentOrdersListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
            <Route
              path="ledger"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                  <AuthHOC component={<StudentLedgerListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
          </Route>
          <Route
            path="/offline-order"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                <AuthHOC component={<OfflineOrderListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/offline-order/add"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                <AuthHOC component={<AddOfflineOrderWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/offline-order/edit/:orderId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                <AuthHOC component={<ViewOfflineOrderLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="order-deatils"
              element={<AuthHOC component={<OrderDetailsFormWrapper />} />}
            />
            <Route
              path="payment-deatils"
              element={<AuthHOC component={<PaymentDetailsFormWrapper />} />}
            />

            <Route
              path="book-deatils"
              element={<AuthHOC component={<BookDetailsFormWrapper />} />}
            />
          </Route>
          <Route
            path="/payment-mode"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/payment-mode"]}>
                <AuthHOC component={<PaymentModeListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/course"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/course"]}>
                <AuthHOC component={<CourseListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/book"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/book"]}>
                <AuthHOC component={<BooksListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/expense-category"
            element={
              <ModuleProtectedRoute
                moduleId={moduleRoutes["/expense-category"]}
              >
                <AuthHOC component={<ExpenseCategoriesListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/level"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/level"]}>
                <AuthHOC component={<LevelListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/user-role"
            element={
              // <ModuleProtectedRoute moduleId={moduleRoutes["/user-role"]}>
              <AuthHOC component={<UserRoleListingWrapper />} />
              // </ModuleProtectedRoute>
            }
          />
          <Route
            path="/subject"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/subject"]}>
                <AuthHOC component={<SubjectListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/faculty"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/faculty"]}>
                <AuthHOC component={<FacultyListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/mode"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/mode"]}>
                <AuthHOC component={<ModeListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/course-type"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/course-type"]}>
                <AuthHOC component={<CourseTypeListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/attempt"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/attempt"]}>
                <AuthHOC component={<AttemptListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route path="/receipt/:id" element={<ReceiptComponent />} />
          <Route path="/download-receipt/:id" element={<ReceiptDownload />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default PageRoutes;
